import { Registry } from '@react-registry'

export const UL = () => {
    return {
        type: 'ul',
    }
}

Registry.register(UL, { id: 'UL', registry: 'v2.deserializer' })